/**
 * Public entry points for the PMB v2 workbench overlay.
 *
 * Open the workbench from any "Generate Pre-Meeting Brief" button:
 *
 *   import { openPmbV2Workbench, PMB_V2_MISSING_LINKEDIN_MESSAGE } from
 *     "~/containers/pre-meeting-brief-v2"
 *
 *   if (!linkedinUrl) {
 *     notification.error({ description: PMB_V2_MISSING_LINKEDIN_MESSAGE })
 *     return
 *   }
 *   openPmbV2Workbench({ linkedinUrl, accountId, opportunityId, ... })
 */
import usePmbV2WorkbenchStore, {
  type PmbV2WorkbenchInput
} from "~/store/pmb-v2-workbench"

export const PMB_V2_MISSING_LINKEDIN_MESSAGE =
  "Need a LinkedIn URL to generate a brief."

export const APOLLO_ID_RE = /^[0-9a-f]{24}$/i

export function openPmbV2Workbench(input: PmbV2WorkbenchInput) {
  usePmbV2WorkbenchStore.getState().open(input)
}

export function closePmbV2Workbench() {
  usePmbV2WorkbenchStore.getState().close()
}

/**
 * Helper: classify a generic id (number or string) into the right channel.
 * Mirrors the old buildPmbV2Url logic — 24-hex strings go to apollo, anything
 * else to account. Callers that already know which channel they have should
 * pass directly via openPmbV2Workbench({ accountId } or { apolloId }).
 */
export function classifyAccountId(id: number | string | null | undefined): {
  accountId?: number | string
  apolloId?: string
} {
  if (id == null) return {}
  const raw = String(id).trim()
  if (!raw) return {}
  if (APOLLO_ID_RE.test(raw)) return { apolloId: raw }
  return { accountId: id }
}

export type { PmbV2WorkbenchInput }
export { default as PreMeetingBriefV2Workbench } from "./pmb-v2-workbench"
export { PMB_FLOW, isPmbV1, type PmbFlow } from "./pmb-flow"
